module.exports = __webpack_public_path__ + "img/logo-ibama.47093a20.svg";